import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '@/components/layout/Logo';

interface SiteFooterProps {
  className?: string;
}

export const SiteFooter: React.FC<SiteFooterProps> = ({ className = '' }) => {
  return (
    <footer className={`relative overflow-hidden border-t border-white/5 bg-[#0a0a0a] px-6 py-12 ${className}`.trim()}>
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 opacity-[0.08]"
        style={{
          backgroundImage:
            'linear-gradient(to bottom, rgba(255,255,255,0.03) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.02) 1px, transparent 1px)',
          backgroundSize: '42px 42px',
        }}
      />
      <div className="pointer-events-none absolute inset-x-0 top-0 h-24 bg-[radial-gradient(circle_at_top,rgba(140,172,255,0.08),transparent_72%)]" />

      <div className="relative mx-auto flex max-w-7xl flex-col items-center justify-between gap-8 md:flex-row">
        {/* Brand */}
        <div className="flex flex-col items-center md:items-start gap-3">
          <Logo size="sm" />
          <div className="flex items-center gap-3 font-mono text-[9px] text-[#767575] uppercase tracking-widest">
            <span>© 2026 SECTOR_7G</span>
            <span className="h-1 w-1 bg-white/20" />
            <Link to="/terms" className="hover:text-white transition-colors">Terms</Link>
            <span className="h-1 w-1 bg-white/20" />
            <Link to="/privacy" className="hover:text-white transition-colors">Privacy</Link>
          </div>
        </div>

        {/* Nav links — right-aligned */}
        <div className="flex flex-wrap gap-8 md:ml-auto">
          <Link
            className="font-['Space_Grotesk'] text-[10px] font-bold uppercase tracking-[0.2em] text-[#acabaa] hover:text-white transition-colors"
            to="/grind"
          >
            Quest Map
          </Link>
          <Link
            className="font-['Space_Grotesk'] text-[10px] font-bold uppercase tracking-[0.2em] text-[#acabaa] hover:text-white transition-colors"
            to="/game-guide"
          >
            Game Guide
          </Link>
          <Link
            className="font-['Space_Grotesk'] text-[10px] font-bold uppercase tracking-[0.2em] text-[#acabaa] hover:text-white transition-colors"
            to="/privacy"
          >
            Privacy
          </Link>
          <Link
            className="font-['Space_Grotesk'] text-[10px] font-bold uppercase tracking-[0.2em] text-[#acabaa] hover:text-white transition-colors"
            to="/terms"
          >
            Terms
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default SiteFooter;
